import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ViaCep } from '../models/viacep';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class ViaCepService {

  constructor(private http: HttpClient) { }

  obterEndereco(cep: string) {
    // return this.http.get<ViaCep>(`https://viacep.com.br/ws/${cep.replace('-', '').replace('.', '').trim()}/json`);

    return this.http.get<ViaCep>(globals.apiUrl + '/api/Cep/BuscarCep',
      {
        params: new HttpParams().set('cep', cep)
      }
    );
  }


}
